export default "__VITE_ASSET__BSfFeIRJ__"